import { useAuth } from "@risalabs_frontend_org/auth-wrapper";

/** Whether the signed-in user can open the Notes inbox and patient summaries. */
export function useClinicalTrialsAdminAccess(): boolean {
  const { user, role } = useAuth();
  return Boolean(
    user?.isSuperAdmin || role?.permissions?.can_admin_clinical_trials,
  );
}
